import { Route, BrowserRouter as Router, Routes } from "react-router-dom"
import { TimeMachine } from "./components/debug/TimeMachine"
import { DeletedDocumentAlert, QueryMonitor } from "./components/global/DeletedDocumentManager"
import { GlobalRefreshAlert } from "./components/global/GlobalRefreshAlert"
import { MutationModal } from "./components/global/MutationModal"
import GlobalMenu from "./components/navigation/GlobalMenu"
import Navbar from "./components/navigation/Navbar"
import { ProcessProvider } from "./contexts/ProcessContext"
import { TimeMachineProvider } from "./contexts/TimeMachineContext"
import { AuthProvider } from "./contexts/AuthContext"
import AbsenceRequest from "./pages/AbsenceRequest"
import AddUser from "./pages/admin/AddUser"
import AbsenceRequests from "./pages/admin/demandes-absence"
import FaireLAppel from "./pages/admin/FaireLAppel"
import NouvelleAnneeConfigurerAnnee from "./pages/admin/nouvelle-annee/ConfigurerNouvelleAnnee"
import NouvelleAnneeConfigurerGroupes from "./pages/admin/nouvelle-annee/ConfigurerGroupes"
import AdminSettings from "./pages/admin/Settings"
import ParfaiteAssiduite from "./pages/admin/statistiques/ParfaiteAssiduite"
import StatistiquesPage from "./pages/admin/statistiques/Statistiques"
import UserDetails from "./pages/admin/utilisateur/[id]"
import Users from "./pages/admin/utilisateurs"
import YoungListPage from "./pages/admin/jeunes"
import Login from "./pages/auth/Login"
import ResetPassword from "./pages/auth/ResetPassword"
import AuthAction from "./pages/auth-action"
import DebugAttendancesIndex from "./pages/debug/attendances"
import DebugAttendances from "./pages/debug/attendances/[young_id]"
import { TodoDetailPage } from "./pages/TodoDetailPage"
import { TodosPage } from "./pages/TodosPage"
import AbsencesAJustifier from "./pages/young/a-justifier"
import AbsenceRequestForm from "./pages/young/AbsenceRequestForm"
import AbsenceRequestsYoung from "./pages/young/demandes-absence"
import YoungSettings from "./pages/young/Settings"
import AbsencesEtRetards from "./pages/admin/absences-et-retards"
import DailySummaryPage from "./pages/admin/statistiques/resume-du-jour"
import NouvelleAnneeIntroduction from "./pages/admin/nouvelle-annee/Introduction"
import ResumeDuJeunePage from "./pages/admin/resume-du-jeune/[id]"
import ParametresApplication from "./pages/admin/parametres-application"
import AttendanceEventPage from "./pages/AttendanceEvent"
import { ProtectedRoute } from "./components/auth/ProtectedRoute"
import Home from "./pages/Home"

function App() {
   return (
      <TimeMachineProvider>
         <ProcessProvider>
            <AuthProvider>
               <Router>
                  <div className="min-h-screen">
                     <TimeMachine />
                     <div className="drawer">
                        <input id="global-drawer" type="checkbox" className="drawer-toggle" />
                        <div className="drawer-content min-h-screen flex flex-col ">
                           <Navbar
                              onGlobalMenuOpen={() =>
                                 document.getElementById("global-drawer")?.click()
                              }
                           />
                           <div className="flex flex-col flex-1 overflow-auto">
                              <Routes>
                                 {/* Public routes ******************************************** */}
                                 <Route path="/" element={<Home />} />
                                 <Route path="/connexion" element={<Login />} />
                                 <Route path="/nouveau-mot-de-passe" element={<ResetPassword />} />
                                 <Route path="/auth-action" element={<AuthAction />} />

                                 {/* For all routes ******************************************** */}

                                 <Route
                                    path="/todos"
                                    element={
                                       <ProtectedRoute>
                                          <TodosPage />
                                       </ProtectedRoute>
                                    }
                                 />
                                 <Route
                                    path="/todo/:id"
                                    element={
                                       <ProtectedRoute>
                                          <TodoDetailPage />
                                       </ProtectedRoute>
                                    }
                                 />

                                 <Route
                                    path="/evenement/:id"
                                    element={
                                       <ProtectedRoute>
                                          <AttendanceEventPage />
                                       </ProtectedRoute>
                                    }
                                 />

                                 {/* Admin routes ******************************************** */}
                                 <Route path="/admin">
                                    <Route
                                       path="ajouter-utilisateur"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <AddUser />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="parametres"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <AdminSettings />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="parametres-application"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <ParametresApplication />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="utilisateurs"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <Users />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="utilisateur/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <UserDetails />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="demandes-absence"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <AbsenceRequests />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="absences-et-retards"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <AbsencesEtRetards />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="faire-l-appel"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <FaireLAppel />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="demande-absence/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <AbsenceRequest />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="resume-du-jour"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <DailySummaryPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="statistiques/"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <StatistiquesPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="statistiques/:opt_id"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <StatistiquesPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="statistiques/parfaite-assiduite"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <ParfaiteAssiduite />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="jeunes"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <YoungListPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="resume-du-jeune/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <ResumeDuJeunePage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="evenement/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <AttendanceEventPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route path="nouvelle-annee">
                                       <Route
                                          path="introduction"
                                          element={
                                             <ProtectedRoute allowedRoles={["admin"]}>
                                                <NouvelleAnneeIntroduction />
                                             </ProtectedRoute>
                                          }
                                       />
                                       <Route
                                          path="configurer-annee"
                                          element={
                                             <ProtectedRoute allowedRoles={["admin"]}>
                                                <NouvelleAnneeConfigurerAnnee />
                                             </ProtectedRoute>
                                          }
                                       />
                                       <Route
                                          path="configurer-groupes"
                                          element={
                                             <ProtectedRoute allowedRoles={["admin"]}>
                                                <NouvelleAnneeConfigurerGroupes />
                                             </ProtectedRoute>
                                          }
                                       />
                                    </Route>
                                 </Route>
                                 {/* Young routes ******************************************** */}

                                 <Route path="/jeune">
                                    <Route
                                       path="parametres"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <YoungSettings />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="nouvelle-demande-absence"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <AbsenceRequestForm />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="demande-absence/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <AbsenceRequest />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="demandes-absence"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <AbsenceRequestsYoung />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="a-justifier"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <AbsencesAJustifier />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="evenement/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <AttendanceEventPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path="absence/:id"
                                       element={
                                          <ProtectedRoute allowedRoles={["young"]}>
                                             <AttendanceEventPage />
                                          </ProtectedRoute>
                                       }
                                    />
                                 </Route>
                                 {/* Other routes ******************************************** */}
                                 <Route path="/dbg-attendances">
                                    <Route
                                       index
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <DebugAttendancesIndex />
                                          </ProtectedRoute>
                                       }
                                    />
                                    <Route
                                       path=":young_id"
                                       element={
                                          <ProtectedRoute allowedRoles={["admin"]}>
                                             <DebugAttendances />
                                          </ProtectedRoute>
                                       }
                                    />
                                 </Route>
                              </Routes>
                           </div>
                        </div>
                        <div className="drawer-side z-50">
                           <label htmlFor="global-drawer" className="drawer-overlay"></label>
                           <div className="menu p-4 w-80 min-h-full bg-base-200 text-base-content ">
                              <GlobalMenu />
                           </div>
                        </div>
                        <MutationModal />
                        <GlobalRefreshAlert />
                        <QueryMonitor />
                        <DeletedDocumentAlert />
                     </div>
                  </div>
               </Router>
            </AuthProvider>
         </ProcessProvider>
      </TimeMachineProvider>
   )
}

export default App
